import React, {PropsWithChildren} from 'react';
import {useFeatureServices} from '../../../use-feature-services';
import {TrackingEvents} from '../../../types/enums/tracking.enum';
import { DataType, EnvironmentType, EventInfoType, LinkType, PersonalizationType, ProcessType, UserType } from '../../../types/tracking';

export interface TrackingContextInterface {
  init: (
    event: TrackingEvents
  ) => void;
}

export const TrackingContext =
  React.createContext<TrackingContextInterface | null>(null);

export const TrackingContextProvider = (props : PropsWithChildren) => {
  const {tracking: trackingManager} = useFeatureServices();

  // const getConfigurations = (model: Model): ConfigurationType => {
  //   let configs: ConfigurationType = {
  //     Manufacturer: 'Volkswagen',
  //     CarlineName: model?.model_name,
  //     EquipmentlineName: model?.trim,
  //     ModelId: model?.model_code,
  //     ModelName: model?.model_name,
  //     ModelYear: model?.model_year as unknown as string,
  //     ExteriorColorCode: model?.exterior_colour?.code,
  //     ExteriorColorName: model?.exterior_colour?.name,
  //     InteriorColorCode: model?.interior_colour?.code,
  //     InteriorColorName: model?.interior_colour?.name,
  //   };

  //   return configs;
  // };

  const track = (
    event: TrackingEvents
  ) => {
    let eventInfo: EventInfoType = {
      brand: 'passenger',
    };

    let user: UserType = {
      loginStatus: false,
      customerType: 'private',
      customerContractsCount: undefined,
      dealerStatus: false,
    };

    let personalization: PersonalizationType = {status: false};

    let link: LinkType = {
      url: window.location.href,
    };

    let environment: EnvironmentType = {
      featureAppId: 'VWSUVW-Poll-Calculation-D6-CA',
    };

    // switch (event) {
    //   case TrackingEvents.SEARCH_CLICK:
    //     link = {...link, name: 'Find a dealer'};
    //     break;
    // }

    let data: DataType = {
      eventInfo,
      user,
      personalization,
      // configuration,
      link,
      environment,
    };

    if (event == TrackingEvents.SEARCH_CLICK) {
      const process: ProcessType = {
        StepName: 'Select Dealer',
      };

      data = {...data, process};
    }

    trackingManager.track(event, data);
  };

  const TrackingContextValue: TrackingContextInterface = {
    init: track,
  };

  return (
    <TrackingContext.Provider value={TrackingContextValue}>
      {props.children}
    </TrackingContext.Provider>
  );
};
